"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var native_1 = __importDefault(require("styled-components/native"));
var react_native_1 = require("react-native");
var DefaultAtomValues_1 = require("../constants/DefaultAtomValues");
var defaultProps = {
    hasShadow: false,
    buttonBorderColor: DefaultAtomValues_1.DefaultAtomColors.transparent,
    buttonBorderRadius: 10,
    buttonBorderWidth: 0,
    buttonColor: DefaultAtomValues_1.DefaultAtomColors.gray,
    buttonSize: 64,
    iconColor: DefaultAtomValues_1.DefaultAtomColors.white,
    iconSize: 30
};
// STYLED COMPONENTS ---------------------------------------------------------------------------------------------------
var StyledButton = native_1.default(react_native_1.TouchableOpacity)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-color: ", ";\n  border-radius: ", "px;\n  border-width: ", ";\n  background-color: ", ";\n  height: ", "px;\n  width: ", "px;\n  align-items: center;\n  justify-content: center;\n"], ["\n  border-color: ", ";\n  border-radius: ", "px;\n  border-width: ", ";\n  background-color: ", ";\n  height: ", "px;\n  width: ", "px;\n  align-items: center;\n  justify-content: center;\n"])), function (props) { return props.buttonBorderColor; }, function (props) { return props.buttonBorderRadius ? props.buttonBorderRadius : props.buttonSize && (props.buttonSize) / 2; }, function (props) { return props.buttonBorderWidth; }, function (props) { return props.buttonColor; }, function (props) { return props.buttonSize; }, function (props) { return props.buttonSize; });
var StyledIcon = native_1.default(react_native_1.Image)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  tint-color: ", ";\n  height: ", ";\n  width: ", ";\n"], ["\n  tint-color: ", ";\n  height: ", ";\n  width: ", ";\n"
    // COMPONENT -----------------------------------------------------------------------------------------------------------
])), function (props) { return props.iconColor; }, function (props) { return props.iconSize; }, function (props) { return props.iconSize; });
// COMPONENT -----------------------------------------------------------------------------------------------------------
exports.ATLAtomIconButton = function (_a) {
    var icon = _a.icon, onPress = _a.onPress, hasShadow = _a.hasShadow, buttonBorderColor = _a.buttonBorderColor, buttonBorderRadius = _a.buttonBorderRadius, buttonBorderWidth = _a.buttonBorderWidth, buttonColor = _a.buttonColor, buttonSize = _a.buttonSize, iconColor = _a.iconColor, iconSize = _a.iconSize;
    // Renders button's icon
    var renderIcon = react_1.useCallback(function () { return (react_1.default.createElement(StyledIcon, { source: icon, iconColor: iconColor, iconSize: iconSize })); }, [icon, iconColor]);
    // Renders full button
    var renderButton = function () { return (react_1.default.createElement(StyledButton, { style: hasShadow && styles.shadow, onPress: onPress, buttonBorderColor: buttonBorderColor, buttonBorderRadius: buttonBorderRadius, buttonBorderWidth: buttonBorderWidth, buttonColor: buttonColor, buttonSize: buttonSize }, renderIcon())); };
    // Returns complete ATLAtomIconButton
    return renderButton();
};
var styles = react_native_1.StyleSheet.create({
    shadow: __assign({ shadowColor: '#000', shadowOpacity: 0.2 }, react_native_1.Platform.select({
        ios: {
            shadowOffset: { width: 0, height: 8 }
        },
        android: {
            elevation: 8,
            overflow: 'hidden'
        }
    }))
});
exports.ATLAtomIconButton.defaultProps = defaultProps;
exports.ATLAtomIconButton.displayName = 'ATLAtomIconButton';
var templateObject_1, templateObject_2;
